"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkupTag = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _SvgBtClose = require("../svg/icons/SvgBtClose");

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c67604ab1{display:inline-flex;box-sizing:border-box;padding:.125rem .3125rem;border-radius:.25rem;max-width:100%;position:relative}.c6e7d2d58{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;text-shadow:0 .0625rem .0625rem rgba(0,0,0,.25);color:#fff}.c03840921{outline:0;background:0 0;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;padding:0;-webkit-user-select:none;-ms-user-select:none;user-select:none;position:absolute;color:#fff;cursor:pointer}.c03840921:hover{opacity:.7}.c03840921:active{opacity:.3}.c910818a7 .c6e7d2d58{margin-right:.9375rem}.cde711b43 .c6e7d2d58{font-size:.875rem;font-weight:400;line-height:1.25rem}.cde711b43 .c03840921{right:-.1875rem;top:-.0625rem}.c5c80f3ce .c6e7d2d58{font-size:.75rem;font-weight:400;line-height:1.125rem}.c5c80f3ce .c03840921{right:-.1875rem;top:-.125rem}.c51b59f7a{background:var(--color-flomni-blue-70)}.ca417dfd1{background:var(--color-flomni-rose-70)}.ca9e56988{background:var(--color-flomni-green-70)}.cb48313b4{background:var(--color-flomni-gray-70)}.c177cac42{background:var(--color-flomni-yellow-50)}");
var styles = {
  root: 'c67604ab1',
  inner: 'c6e7d2d58',
  button: 'c03840921',
  '--closable': 'c910818a7',
  '--size-usual': 'cde711b43',
  '--size-small': 'c5c80f3ce',
  '--view-action': 'c51b59f7a',
  '--view-warning': 'ca417dfd1',
  '--view-success': 'ca9e56988',
  '--view-light': 'cb48313b4',
  '--view-bright': 'c177cac42'
};

var MarkupTag = function MarkupTag(props) {
  var view = props.view,
      children = props.children,
      onClose = props.onClose,
      classes = props.classes,
      size = props.size;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.view[view], cn.size[size], (0, _defineProperty2.default)({}, cn.closable, !!onClose))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.inner
  }, children), !onClose ? null : /*#__PURE__*/_react.default.createElement("button", {
    onClick: onClose,
    className: cn.button
  }, /*#__PURE__*/_react.default.createElement(_SvgBtClose.SvgBtClose, null)));
};

exports.MarkupTag = MarkupTag;
var view = ['action', 'warning', 'success', 'light', 'bright'];
var size = ['usual', 'small'];
MarkupTag.modes = {
  view: view,
  size: size
};
MarkupTag.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,
  onClose: _propTypes.func,

  /* styling modificators */
  view: (0, _propTypes.oneOf)(view),
  size: (0, _propTypes.oneOf)(size),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
MarkupTag.defaultProps = {
  view: 'action',
  size: 'usual',
  classes: {},
  onClose: null
};